import { ErrorService } from './error.service';
import { ErrorInterceptorProvider } from './error.interceptor.provider';
import { errorBarComponent } from './errorBar/errorBar.component';

export default angular
  .module('ng1-error-handling', [])
  .service('errorService', ErrorService)
  .provider('errorInterceptor', ErrorInterceptorProvider)
  .component('errorBar', errorBarComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-error-handling/src/index.js